<div class="community-history" *transloco="let t">
  @if (showTitle) {
    <h4 class="h6 mb-2">{{ t('community.history.title') }}</h4>
  }

  @if (loading()) {
    <div class="text-muted small">{{ t('community.history.loading') }}</div>
  } @else if (error()) {
    <div class="alert alert-danger py-2 mb-2 small">{{ error() }}</div>
  } @else if (versions().length === 0) {
    <div class="text-muted small">{{ t('community.history.no_versions') }}</div>
  } @else {
    <ol class="community-history__list">
      @for (v of versions(); track v.version_id ?? 'current') {
        <li class="community-history__item" [class.community-history__item--current]="v.event === 'current'">
          <div class="community-history__meta small text-muted">
            <strong class="me-2">
              @if (v.event === 'current') { {{ t('community.history.current') }} }
              @else if (v.event === 'create') { {{ t('community.history.event_create') }} }
              @else { {{ t('community.history.event_update') }} }
            </strong>
            <span class="me-2">{{ t('community.history.version_from') }} {{ v.changed_at | date:'medium' }}</span>
            @if (v.editor_name) {
              <span>· {{ v.editor_name }}</span>
            }
          </div>

          @if (target === 'thread' && v.state.title !== undefined) {
            <div class="community-history__field">
              <span class="community-history__label">{{ t('community.history.title_field') }}:</span>
              <strong>{{ v.state.title }}</strong>
            </div>
          }
          @if (v.state.body !== undefined) {
            <div class="community-history__field">
              <span class="community-history__label">{{ t('community.history.body_field') }}:</span>
              <div class="community-history__body" [innerHTML]="safe(v.state.body)" appCommunityVideoEmbeds></div>
            </div>
          }
        </li>
      }
    </ol>
  }
</div>
